import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import user from './user';
import template from './template';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    collapsedTemplate: {},
    isLocalAIDisabled: false,
    autoSavingInterval: null,
    ready: {
      userLoaded: false,
      languagesLoaded: false,
      defaultDataLoaded: false,
      templateGalleryLoaded: false,
      modulesLoaded: false,
    },
    languages: null,
    saving: false,
    building: false,
    buildingGS: false,
    buyingGS: false,
    dialogs: {
      shouldShowSystemDownDialog: false,
      requestResetPassword: null,
      passwordUpdated: null,
      loginResultDialogVisible: false,
      endOfWizardDialogVisible: false,
      showGSUrlDialogVisible: false,
      GSUrl: false,
      snackbar: false,
      showScreenshotsDialog: true,
    },
    loginReminderProgressInitValue: 8, // seconds
    loginReminderProgressCurrentValue: 8, // seconds
    loggedin: false,
    loading: false,
    activeTemplate: {
      version: '1.0',
      timestamp: null,
      id: null,
      name: 'ui_new_template_name',
      description: '',
      moneyUnits: 'mln',
      creatorId: 1,
      userId: 1,
      language: 'en',
      showOnboardingDialog: false,
      isGenerating: 'done',
      isPreviewVisible: true,
      data: {
        activeSectionId: 'section_sales',
        sections: null,
        modules: [
          {
            id: 'module_cover',
            title: 'module_cover',
            description: 'module_description_cover',
            colorScheme: {
              tabColor: '00FFFF61',
              tabColorRGB: {
                red: 255,
                green: 255,
                blue: 97,
              },
              color: '000000',
            },
            file: null,
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_cover',
              previewHTML: 'fooo',
            },
            templateSectionCfg: null,
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            isIncluded: true,
          },
          {
            id: 'module_content',
            hideInEditor: true,
            description: '',
            colorScheme: null,
            file: null,
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_content',
              previewHTML: '',
            },
            templateSectionCfg: null,
            isEnabled: true,
            isInitialized: false,
            isIncluded: true,
          },
          {
            id: 'module_dashboard',
            hideInEditor: true,
            description: '',
            colorScheme: null,
            file: null,
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_dashboard',
              previewHTML: null,
            },
            templateSectionCfg: null,
            isEnabled: true,
            isInitialized: false,
            sheetCategory: 'outputs',
            isIncluded: true,
            builderSkipFormatting: true,
          },
          {
            id: 'module_assumptions',
            description: 'module_highlights_assumptions',
            colorScheme: {
              tabColor: 'ffe742',
              tabColorRGB: {
                red: 28,
                green: 47,
                blue: 253,
              },
            },
            file: 'assumptions.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_assumptions',
              previewHTML: '',
            },
            templateSectionCfg: [
              {
                id: 'section_timeline',
                title: 'section_timeline',
                description: 'section_timeline__description',
                isEnabled: true,
                hasSectionSettings: true,
                isAllowed: true,
                isInitialized: false,
                isEditingSettings: false,
                autoSelectFirstInput: true,
              },
              {
                id: 'section_environment',
                title: 'section_environment',
                description: 'section_environment__description',
                sections: [
                  {
                    id: 'section_currency',
                    title: 'section_currency',
                    coreResourceTypes: [
                      'currency',
                    ],
                    sectionResources: [],
                    addResourceLabel: 'Currency',
                    isMultipleCurrenciesEnabled: false,
                    isAllowed: true,
                  },
                  {
                    id: 'section_taxes',
                    title: 'section_taxes',
                    coreResourceTypes: [
                      'taxincome',
                      'taxproperty',
                    ],
                    sectionResources: [],
                    addResourceLabel: 'ui_add_taxproperty_btn',
                    isAllowed: true,
                  },
                  {
                    id: 'section_depreciation',
                    title: 'section_depreciation',
                    coreResourceTypes: [
                      'deprgroup',
                    ],
                    sectionResources: [],
                    addResourceLabel: 'ui_add_deprgroup_btn',
                    isDepreciationEnabled: false,
                    isAllowed: true,
                    isAddingResource: false,
                  },
                ],
                isEnabled: true,
                hasSectionSettings: true,
                isAllowed: true,
                isInitialized: false,
                isEditingSettings: false,
                autoSelectFirstInput: true,
              },
            ],
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            sheetCategory: 'inputs',
            isIncluded: true,
          },
          {
            id: 'module_revenue',
            description: 'module_highlights_revenue',
            colorScheme: {
              tabColor: 'dedede',
              tabColorRGB: {
                red: 153,
                green: 153,
                blue: 153,
              },
              color: '000000',
            },
            icon: 'mdi-shopping-outline',
            file: 'revenue.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_revenue',
              previewHTML: '',
            },
            templateSectionCfg: {
              id: 'section_sales',
              title: 'section_sales',
              titleLong: 'section_sales',
              description: 'section_sales__description',
              empty: 'section_sales--empty',
              coreResourceTypes: [
                'service',
              ],
              sectionResources: [],
              addResourceLabel: 'ui_add_sales_btn',
              isEnabled: true,
              isAllowed: true,
              isInitialized: false,
              isAddingResource: false,
              suggestedResources: [],
              isGenerating: true,
              isEditingSettings: false,
              isCollapsed: false,
              isAIGenerationEnabled: true,
            },
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            sheetCategory: 'calculations',
            isIncluded: true,
          },
          {
            id: 'module_cos',
            nameLong: 'module_cos_name__long',
            description: 'module_highlights_cos',
            colorScheme: {
              tabColor: 'dedede',
              tabColorRGB: {
                red: 153,
                green: 153,
                blue: 153,
              },
              color: '000000',
            },
            icon: 'mdi-wrench-cog',
            file: 'cos.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_cos',
              previewHTML: '',
            },
            templateSectionCfg: {
              id: 'section_cos',
              title: 'section_cos',
              titleLong: 'section_cos__title__long',
              description: 'section_cos__description',
              empty: 'section_cos--empty',
              coreResourceTypes: [
                'cos',
              ],
              sectionResources: [],
              addResourceLabel: 'ui_add_cos_btn',
              isEnabled: true,
              canDisable: true,
              isAllowed: true,
              isInitialized: false,
              isAddingResource: false,
              suggestedResources: [],
              isGenerating: true,
              isEditingSettings: false,
              isCollapsed: false,
              isAIGenerationEnabled: true,
            },
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            canSkip: true,
            sheetCategory: 'calculations',
            isIncluded: true,
          },
          {
            id: 'module_sga',
            nameLong: 'module_sga_name__long',
            description: 'module_highlights_sga',
            colorScheme: {
              tabColor: 'dedede',
              tabColorRGB: {
                red: 153,
                green: 153,
                blue: 153,
              },
              color: '000000',
            },
            icon: 'mdi-account-tie',
            file: 'sga.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_sga',
              previewHTML: '',
            },
            templateSectionCfg: {
              id: 'section_sga',
              title: 'section_sga',
              titleLong: 'section_sga__title__long',
              description: 'section_sga__description',
              empty: 'section_sga--empty',
              coreResourceTypes: [
                'sga',
              ],
              sectionResources: [],
              addResourceLabel: 'ui_add_sga_btn',
              isEnabled: true,
              canDisable: true,
              isAllowed: true,
              isInitialized: false,
              isAddingResource: false,
              suggestedResources: [],
              isGenerating: true,
              isEditingSettings: false,
              isCollapsed: false,
              isAIGenerationEnabled: true,
            },
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            canSkip: true,
            sheetCategory: 'calculations',
            isIncluded: true,
          },
          {
            id: 'module_wc',
            nameLong: 'module_wc_name__long',
            description: 'module_highlights_wc',
            colorScheme: {
              tabColor: 'dedede',
              tabColorRGB: {
                red: 153,
                green: 153,
                blue: 153,
              },
              color: '000000',
            },
            icon: 'mdi-rotate-3d-variant',
            file: 'wc.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_wc',
              previewHTML: '',
            },
            templateSectionCfg: {
              id: 'section_wc',
              title: 'section_wc',
              description: 'section_wc__description',
              isEnabled: true,
              isVisible: false,
              hasSectionSettings: true,
              isAllowed: true,
              isInitialized: false,
              isEditingSettings: false,
              isGenerating: true,
              isCollapsed: false,
            },
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            canSkip: true,
            sheetCategory: 'calculations',
            isIncluded: true,
          },
          {
            id: 'module_fixedassets',
            nameLong: 'module_fixedassets_name__long',
            description: 'module_highlights_fixedassets',
            colorScheme: {
              tabColor: 'dedede',
              tabColorRGB: {
                red: 153,
                green: 153,
                blue: 153,
              },
              color: '000000',
            },
            icon: 'mdi-domain',
            file: 'fixedassets.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_fixedassets',
              previewHTML: '',
            },
            templateSectionCfg: {
              id: 'section_fixedassets',
              isAllowed: true,
              title: 'section_fixedassets',
              description: 'section_fixedassets__description',
              empty: 'section_fixedassets--empty',
              coreResourceTypes: [
                'fixedasset',
              ],
              sectionResources: [],
              addResourceLabel: 'ui_add_fixedasset_btn',
              isEnabled: true,
              canDisable: true,
              isInitialized: false,
              hasSectionSettings: true,
              isAddingResource: false,
              suggestedResources: [],
              isGenerating: true,
              isEditingSettings: false,
              isCollapsed: false,
              isAIGenerationEnabled: true,
            },
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            canSkip: true,
            sheetCategory: 'calculations',
            isIncluded: true,
          },
          {
            id: 'module_financing',
            nameLong: 'module_financing_name__long',
            description: 'module_highlights_financing',
            colorScheme: {
              tabColor: 'dedede',
              tabColorRGB: {
                red: 153,
                green: 153,
                blue: 153,
              },
              color: '000000',
            },
            icon: 'mdi-bank-outline',
            file: 'fin.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_financing',
              previewHTML: '',
            },
            templateSectionCfg: {
              id: 'section_financing',
              title: 'section_financing',
              description: 'section_financing__description',
              empty: 'section_financing--empty',
              coreResourceTypes: [
                'equity',
                'loan',
                'financing',
              ],
              sectionResources: [],
              addResourceLabel: 'add_financing',
              isEnabled: true,
              isVisible: false,
              canDisable: true,
              isAllowed: true,
              isInitialized: false,
              isEditingSettings: false,
              isAddingResource: false,
              isGenerating: true,
              isCollapsed: false,
              isAIGenerationEnabled: false,
            },
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            canSkip: true,
            sheetCategory: 'calculations',
            isIncluded: true,
          },
          {
            id: 'module_is',
            nameLong: 'module_is_name__long',
            description: 'module_highlights_is',
            colorScheme: {
              tabColor: '1C2FFD',
              tabColorRGB: {
                red: 255,
                green: 231,
                blue: 66,
              },
            },
            file: 'is.m',
            previewCfg: {
              isInitialized: false,
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_is',
              previewHTML: '...',
            },
            templateSectionCfg: null,
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            sheetCategory: 'outputs',
            isIncluded: true,
          },
          {
            id: 'module_bs',
            nameLong: 'module_bs_name__long',
            description: 'module_highlights_bs',
            colorScheme: {
              tabColor: '1C2FFD',
              tabColorRGB: {
                red: 255,
                green: 231,
                blue: 66,
              },
            },
            file: 'bs.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_bs',
              previewHTML: '',
            },
            templateSectionCfg: null,
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            sheetCategory: 'outputs',
            isIncluded: true,
          },
          {
            id: 'module_cf',
            nameLong: 'module_cf_name__long',
            description: 'module_highlights_cf',
            colorScheme: {
              tabColor: '1C2FFD',
              tabColorRGB: {
                red: 255,
                green: 231,
                blue: 66,
              },
            },
            file: 'cf.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_cf',
              previewHTML: '',
            },
            templateSectionCfg: null,
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            sheetCategory: 'outputs',
            isIncluded: true,
          },
          {
            id: 'module_ip',
            nameLong: 'module_ip_name__long',
            description: 'module_highlights_ip',
            colorScheme: {
              tabColor: '1C2FFD',
              tabColorRGB: {
                red: 28,
                green: 47,
                blue: 253,
              },
            },
            file: 'ia.m',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_ip',
              previewHTML: '',
            },
            templateSectionCfg: {
              id: 'section_npv',
              title: 'section_npv',
              description: 'section_npv__description',
              isEnabled: true,
              isVisible: false,
              canDisable: true,
              isAllowed: true,
              isInitialized: false,
              isEditingSettings: false,
              hasSectionSettings: true,
              icon: 'mdi-google-analytics',
              isCollapsed: false,
            },
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            canSkip: true,
            sheetCategory: 'outputs',
            isIncluded: true,
          },
          {
            id: 'module_ratios',
            nameLong: 'module_ratios_name__long',
            description: 'module_highlights_ratios',
            hideInEditor: false,
            file: 'ratios.m',
            colorScheme: {
              tabColor: 'f36f2e',
              tabColorRGB: {
                red: 230,
                green: 145,
                blue: 56,
              },
            },
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_ratios',
              previewHTML: '',
            },
            templateSectionCfg: null,
            isEnabled: false,
            isInitialized: false,
            isNavigatable: true,
            canSkip: true,
            sheetCategory: 'outputs',
            isIncluded: true,
          },
          {
            id: 'module_charts',
            nameLong: 'module_charts_name__long',
            description: 'module_highlights_charts',
            hideInEditor: false,
            file: null,
            colorScheme: {
              tabColor: 'f36f2e',
              tabColorRGB: {
                red: 230,
                green: 145,
                blue: 56,
              },
            },
            icon: 'mdi-chart-line',
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_charts',
              previewHTML: '',
            },
            templateSectionCfg: null,
            isEnabled: true,
            isInitialized: false,
            isNavigatable: true,
            canSkip: true,
            sheetCategory: 'outputs',
            isIncluded: true,
          },
          {
            id: 'module_chartsdata',
            nameLong: 'module_chartsdata_name__long',
            description: 'module_highlights_chartsdata',
            hideInEditor: true,
            file: 'chartsdata.m',
            colorScheme: {
              tabColor: 'dedede',
              tabColorRGB: {
                red: 153,
                green: 153,
                blue: 153,
              },
              color: '000000',
            },
            previewCfg: {
              isRowsExpanded: false,
              isUpdating: false,
              highlights: 'module_highlights_chartsdata',
              previewHTML: '',
            },
            templateSectionCfg: null,
            isEnabled: false,
            isInitialized: false,
            sheetCategory: 'outputs',
            isIncluded: true,
          },
        ],
        divisions: [{
          id: 0,
          name: 'Division1',
          sectionResources: [],
          faHasExpCash: false,
        }],
        coreResources: [{
          id: 0,
          name: 'section_currency__currency-name',
          rel: 'currency',
          units: '',
          value: 1,
          isDefault: true,
          consists_of: [],
        }],
      },
      staticGSUrl: null,
      price: null,
      staticId: null,
    },
    error: null,
    currentPageTitle: null,
    menuItems: {
      home: {
        title: 'finmodelbuilder',
        href: 'https://www.finmodelbuilder.com',
      },
      login: {
        title: 'ui_left_menu__login',
        icon: 'mdi-key',
        href: '/',
      },
      templates: {
        title: 'ui_templates__recent',
        icon: 'mdi-format-list-bulleted-square',
        href: '/templates',
      },
      settings: {
        title: 'ui_left_menu__settings',
        icon: 'mdi-cog',
        href: '/settings',
      },
      feedback: {
        title: 'ui_left_menu__feedback',
        icon: 'mdi-message-text',
        href: '/feedback',
        iconColor: '#651fff',
      },
      template: {
        title: '',
        icon: 'mdi-table-large',
        href: 'template',
      },
    },
    templateGallery: [],
    dialogScrollYPosition: null,
    mode: false, // static or not
    isGeneratingSampleData: false,
    isPreviewDataLoaded: false,
    isEditingToolsVisible: false,
    isLocked: null,
  },
  mutations: {
    updatePageTitle(state, value) {
      // eslint-disable-next-line
      state.currentPageTitle = value;
    },
    updateLoggedIn(state, data) {
      state.loggedin = data;
    },
    updateState(state, cfg) {
      // eslint-disable-next-line
      this._vm._.set(state, cfg.path, cfg.value);
    },
    updateModuleHTML(state, { index, updatedModule }) {
      const { modules } = state.activeTemplate.data;
      // eslint-disable-next-line
      modules.splice(index, 1, updatedModule);
      // eslint-disable-next-line
      this._vm._.set(state, 'activeTemplate.data.modules', modules);
    },
  },
  actions: {
    // eslint-disable-next-line
    async getOpenAI({ state, commit }, cfg) {
      console.log('... calling AI');
      const { language } = state.user.settings;
      const { searchString, sectionId } = cfg;
      let response;
      if (state.isLocalAIDisabled && window.location.hostname === 'localhost') {
        response = await new Promise((resolve) => {
          setTimeout(() => {
            let rel;
            switch (sectionId) {
              case 'section_sales':
                rel = 'service';
                break;
              case 'section_cos':
                rel = 'cos';
                break;
              case 'section_sga':
                rel = 'sga';
                break;
              case 'section_fixedassets':
                rel = 'fixedasset';
                break;
              default:
                //
            }
            const openAIResult = {
              data: {
                suggestions: [
                  {
                    id: 0,
                    name: 'Coffee',
                    rel,
                    isSelected: false,
                  },
                  {
                    id: 1,
                    name: 'Tea',
                    rel,
                    isSelected: false,
                  },
                  {
                    id: 2,
                    name: 'Pastries',
                    rel,
                    isSelected: false,
                  },
                  {
                    id: 3,
                    name: 'Sandwiches',
                    rel,
                    isSelected: false,
                  },
                ],
              },
            };
            resolve(openAIResult);
          }, 1500);
        });
      } else {
        response = await axios.get(`/api/suggestions/${language}/${sectionId}/${searchString}`).catch((err) => {
          console.dir(err);
        });
      }

      let suggestions = [];
      if (!response || !Object.keys(response.data).length) {
        alert('Server error, please try again later');
      } else {
        // preselect all suggestions
        suggestions = response.data.suggestions.map((suggestion) => {
          // eslint-disable-next-line
          suggestion.isSelected = true;
          return suggestion;
        });
      }
      // save to section
      const sectionIndex = state.activeTemplate.data.sections.findIndex((section) => section.id === sectionId);
      commit('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].suggestedResources`,
        value: suggestions,
      });
      return suggestions;
    },
    startHealthCheck({ state, commit }) {
      setInterval(async () => {
        const response = await axios.get('/healthcheck').catch((err) => {
          console.dir(err);
        });
        if (!response || !response.data) {
          commit('updateLoggedIn', false);
          this.dispatch('handleServerError');
        } else {
          // hide system down modal if open
          // eslint-disable-next-line
          if (state.dialogs.shouldShowSystemDownDialog) {
            commit('updateState', {
              path: 'dialogs.shouldShowSystemDownDialog',
              value: false,
            });
            // reload the page in case it failed to load previously
            window.location.reload();
          }
        }
      }, 60 * 1000);
    },
    // eslint-disable-next-line
    log({}, cfg) {
      axios.post('/api/template/log', cfg);
    },
    // eslint-disable-next-line
    handleServerError({ commit }, error) {
      if (!error) {
        commit('updateState', {
          path: 'dialogs.shouldShowSystemDownDialog',
          value: true,
        });
        // eslint-disable-next-line
        // this._vm.router.push('/systemDown');
      } else {
        console.dir(error.response.config.url);
        switch (error.response.status) {
          case 500:
            // router.push('/system-down');
            break;
          default:
            //
        }
      }
    },

    // eslint-disable-next-line
    async shareFeedback({}, data) {
      const { message, email } = data;
      await axios.post('/api/user/shareFeedback', { message, email });
    },
    async checkToSaveLocalTemplates({ commit, state }) {
      const localDataJSON = localStorage.getItem('finmodelbuilder');
      if (localDataJSON) {
        const localData = JSON.parse(localDataJSON);
        if (localData.templates.length) {
          // eslint-disable-next-line
          const wantsToSaveLocalTemplates = confirm(`Found ${localData.templates.length} local templates, would you like to add them to your library?`);
          if (wantsToSaveLocalTemplates) {
            localData.templates.forEach((t) => {
              const nameSuffix = new Date().toUTCString();
              // eslint-disable-next-line
              t.name += ` - ${nameSuffix}`;
            });
            const mergedTemplates = state.user.templates;
            mergedTemplates.unshift(...localData.templates);
            commit('updateState', {
              path: 'user.templates',
              value: mergedTemplates,
            });
            // save user
            this.dispatch('saveUser');

            // hide login reminder snackbar
            this.dispatch('updateState', {
              path: 'dialogs.snackbar',
              value: false,
            });
          }
          // clear localStorage
          localStorage.removeItem('finmodelbuilder');
        }
      }
    },
    async getDefaultTemplateData({ commit }) {
      let response;
      try {
        response = await axios.get('/api/template/default');
        commit('updateState', {
          path: 'defaultTemplateConfig',
          value: response.data,
        });
        commit('updateState', {
          path: 'ready.defaultDataLoaded',
          value: true,
        });
      } catch (e) {
        this.dispatch('handleServerError', e);
      }
    },
    async getLanguageData({ commit }) {
      let response;
      try {
        response = await axios.get('/api/template/languages');
        commit('updateState', {
          path: 'languages',
          value: response.data,
        });
        commit('updateState', {
          path: 'ready.languagesLoaded',
          value: true,
        });
      } catch (e) {
        this.dispatch('handleServerError', e);
      }
    },
    async getTemplateGallery({ commit }) {
      let response;
      try {
        response = await axios.get('/api/template/gallery');
        commit('updateState', {
          path: 'templateGallery',
          value: response.data,
        });
      } catch (e) {
        this.dispatch('handleServerError', e);
      }
    },
    /*
    async getModulesData({ commit, state }) {
      let response;
      try {
        response = await axios.get('/api/template/modules');
        const modules = response.data;
        // commit('updateState', {
        //   path: 'modules',
        //   value: modules,
        // });
        // update preview sections
        const previewModules = modules.reduce((arr, module) => {
          if ((module.previewCfg && !module.hideInEditor) || state.mode === 'static') {
            const mappedToSectionId = module.templateSectionCfg && module.templateSectionCfg.id;
            // eslint-disable-next-line
            module.mappedToSectionId = mappedToSectionId;
            arr.push(module);
            // arr.push({
            //   id: module.id,
            //   nameLong: module.nameLong,
            //   sheetId: module.id,
            //   title: module.id,
            //   description: module.previewCfg.description,
            //   highlights: module.previewCfg.highlights,
            //   isInitialized: false,
            //   previewHTML: '',
            //   isUpdating: false,
            //   isCollapsed: false,
            //   mappedToSectionId,
            // });
          }
          return arr;
        }, []);
        commit('updateState', {
          path: 'previewModules',
          value: previewModules,
        });
        commit('updateState', {
          path: 'ready.modulesLoaded',
          value: true,
        });
      } catch (e) {
        this.dispatch('handleServerError', e);
      }
    },

     */
    // eslint-disable-next-line
    async getTemplateGalleryItem({}, cfg) {
      const { templateId, userId } = cfg;
      let response;
      try {
        response = await axios.get(`/api/template/gallery/${templateId}/${userId}`);
      } catch (e) {
        this.dispatch('handleServerError', e);
      }
      return response.data;
    },
    updateState({ commit }, cfg) {
      commit('updateState', cfg);
    },
    /*
    updateTemplateUuid({ commit }) {
      // eslint-disable-next-line
      const uuid = storeUtils.uuidv4();
      commit('updateState', {
        path: 'activeTemplate.uuid',
        value: uuid,
      });
      // eslint-disable-next-line
      this._vm.router.replace(`/template/${uuid}`);
    },

     */
    async getAnalytics() {
      const response = await axios.get('/api/analytics/').catch((err) => {
        console.dir(err);
      });
      console.log(response);
    },
  },
  getters: {
    selectedResources(state) {
      const envResourcesSelected = state.activeTemplate.data.env.sectionResources.filter((resource) => resource.isSelected);
      const divResourcesSelected = state.activeTemplate.data.divisions[0].sectionResources.filter((resource) => resource.isSelected);
      return [...envResourcesSelected, ...divResourcesSelected];
    },
    ready(state) {
      const {
        userLoaded,
        languagesLoaded,
        defaultDataLoaded,
        // modulesLoaded,
      } = state.ready;
      return userLoaded && languagesLoaded && defaultDataLoaded;
    },
    sections(state) {
      // refresh section resources between sections
      // normalize sections data
      // eslint-disable-next-line
      const { sections } = state.activeTemplate.data;
      const divisionSectionResources = state.activeTemplate.data.divisions[0].sectionResources;
      const result = sections.map((section) => {
        if (typeof section.coreResourceTypes !== 'undefined') {
          // eslint-disable-next-line
          section.sectionResources = divisionSectionResources.filter((sectionResource) => {
            return section.coreResourceTypes.includes(sectionResource.coreResource.rel);
          });
        }

        // check for sub-sections in env
        if (section.sections) {
          // eslint-disable-next-line
          section.sections.forEach((section) => {
            // eslint-disable-next-line
            section.sectionResources = state.activeTemplate.data.env.sectionResources.filter((sectionResource) => {
              return section.coreResourceTypes.includes(sectionResource.coreResource.rel);
            });
            // eslint-disable-next-line
            section.isEditingSettings = false;
          });
        }
        return section;
      });
      // console.log('sections updated');
      return result;
    },
    // TODO - need this one below?
    previewedModules(state) {
      return state.activeTemplate.data.modules;
      /*
      const h = state.activeTemplate.data.modules[0].previewCfg.previewHTML;
      console.log(h);
      const { modules } = state.activeTemplate.data;
      debugger;
      const result = modules.reduce((arr, module) => {
        if (module.isEnabled && !module.hideInEditor) {
          const mappedToSection = module.mappedToSectionId && this.getSectionById(module.mappedToSectionId);
          if (mappedToSection) {
            // eslint-disable-next-line
            module.mappedToSection = mappedToSection;
            // eslint-disable-next-line
            // previewModule.icon = mappedToSection.icon;
            // eslint-disable-next-line
            // previewModule.canSkip = mappedToSection.canSkip;

            // add some runtime props
            // eslint-disable-next-line
            module.isDisabling = mappedToSection.isDisabling;

            // eslint-disable-next-line
            // previewModule.isEditingSettings = mappedToSection.isEditingSettings;
            // eslint-disable-next-line
            module.isEnabled = mappedToSection.isEnabled;
            arr.push(module);
          } else {
            arr.push(module);
            // if was supposed to have a section, add it as disabled
            // this.createSection(previewModule);
          }
        }
        return arr;
      }, []);
      return result;

       */
    },
  },
  modules: {
    user,
    template,
  },
});

/*


    getMessageToShare(templateIndex) {
      const template = this.$store.state.user.templates[templateIndex];
      const message = 'Hey, check out this template:'
      + `\n\n${template.name}`
      + `\n${template.description}`
      + `\n\nAll-in cost: ${this.formatAsCurrency(template.initialCost.total)}`
      + `\nRent: ${this.formatAsCurrency(template.exitStrategy.rent.total)}`
      + `\nOpex: ${this.formatAsCurrency(template.opex.total)}`
      + `\n\nCap Rate: ${template.output.capRate}`
      + `\nCap Rate w/fin: ${template.output.capRateWFinancing}`;
      console.log(message);
      return message;
    },
    shareWhatsApp(event, templateIndex) {
      event.preventDefault();
      const message = this.getMessageToShare(templateIndex);

      const linkWhatsapp = document.getElementById('link-whatsapp');
      const whatsappMessageEncoded = window.encodeURIComponent(message);
      const linkWhatsappPrefix = 'whatsapp://send?text=';
      linkWhatsapp.href = linkWhatsappPrefix + whatsappMessageEncoded;
      linkWhatsapp.click();
      // linkWhatsapp.parentElement.removeChild(linkWhatsapp);
    },
    shareFacebook(event, templateIndex) {
      event.preventDefault();
      const message = this.getMessageToShare(templateIndex);
      // const linkFacebook = document.getElementById('link-facebook');
      const textArea = document.createElement('textarea');
      textArea.value = message;
      document.body.insertBefore(textArea, document.body.firstChild);

      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      textArea.parentElement.removeChild(textArea);

      // eslint-disable-next-line
      alert('Content copied to clipboard. You can paste it in your Facebook message');


      const link = document.createElement('a');
      link.href = 'https://m.me';
      link.target = '_blank';
      document.body.insertBefore(link, document.body.firstChild);
      link.click();
      // link.parentElement.removeChild(link);
    },
    shareEmail(event, templateIndex) {
      event.preventDefault();
      const message = this.getMessageToShare(templateIndex);
      console.log(message);
      // const sendEmail = document.querySelector('.js-email');
      // sendEmail.addEventListener('click', (e) => {
      //   e.preventDefault();

      //   // cancel if email empty
      //   const inputEmail = document.querySelector('.input-email');
      //   const email = inputEmail.value;
      //   const r = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      //   if (!r.test(email)) {
      //     alert('Email has wrong format')
      //     return;
      //   }

      //   // store email address
      //   const savedEmailsJSON = localStorage.getItem('getcomps');
      //   let savedEmails = [];
      //   if (savedEmailsJSON) {
      //     savedEmails = JSON.parse(savedEmailsJSON).emails;
      //   }
      //   savedEmails.unshift(email);
      //   localStorage.setItem('getcomps', JSON.stringify({ emails: savedEmails }));


      //   staticMapUrl = Export(map);
      //   // return
      //   fetch('/email', {
      //       method: 'POST',
      //       body: JSON.stringify({
      //         email: email,
      //         data: message,
      //         staticMapUrl,
      //       }),
      //       headers: {
      //         'Accept': 'application/json',
      //         'Content-Type': 'application/json'
      //       },
      //     })
      //     .then((response) => {
      //       return response.text();
      //     })
      //     .then((data) => {
      //       if (data === 'ok') {
      //         alert('Email sent');
      //       } else {
      //         alert('There was a problem sending this email');
      //       }
      //       console.log(data);
      //       // alert(92);
      //     })
      // });
    },

 */
